import { render, staticRenderFns } from "./EventItemView.vue?vue&type=template&id=67d2a898&"
import script from "./EventItemView.vue?vue&type=script&lang=js&"
export * from "./EventItemView.vue?vue&type=script&lang=js&"
import style0 from "./EventItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports